import * as React from 'react';
import { WidgetLayout } from './parts/WidgetLayout';
import { NotAvailableScreen } from './parts/NotAvailableScreen';
import { RoomTypeFilter } from './parts/RoomTypeFilter';
import { LayoutsCards } from './parts/LayoutsCards';
import { OffersLinks } from './parts/OffersLinks';
import { useLayouts } from '../../hooks';
import { useTracking } from '../../hooks/useTracking';
import { Controls } from './parts/Controls';
import { Pagination } from './parts/Pagination';
import { LayoutModal } from '../LayoutModal';
import { useLayoutModal } from '../../hooks/useLayoutModal';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const Layouts = _ref => {
  let {
    newbuildingId,
    houseId,
    roomsCountList,
    isHouseLayoutsAvailable,
    pageTypeJK,
    callButton,
    onHouseFilterReset,
    isLayoutModalDisabled,
    favoriteButton,
    isQueryParamsEnabled
  } = _ref;
  const {
    layouts,
    onLayoutsReset,
    roomType,
    onRoomTypeChange,
    isLoading,
    isError,
    offersLinks,
    pagination
  } = useLayouts({
    newbuildingId,
    houseId,
    isHouseLayoutsAvailable,
    isQueryParamsEnabled
  });
  const {
    trackListingLinkClick,
    trackLayoutModalOpen,
    trackTourClick,
    trackFlatCardClick,
    trackHeaderLinkClick
  } = useTracking({
    newbuildingId,
    pageTypeJK,
    houseId
  });
  const {
    isOpened,
    onClose,
    onReset,
    onLayoutCardClick,
    loading: isLayoutLoading,
    layoutImageUrl,
    layoutOffers
  } = useLayoutModal({
    newbuildingId,
    houseId,
    layouts,
    isLayoutModalDisabled
  });
  if (!isHouseLayoutsAvailable) {
    return /*#__PURE__*/_jsx(WidgetLayout, {
      children: /*#__PURE__*/_jsx(NotAvailableScreen, {
        onHouseFilterReset: onHouseFilterReset
      })
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(WidgetLayout, {
      children: [!isError && /*#__PURE__*/_jsx(RoomTypeFilter, {
        roomsCountList: roomsCountList,
        onChange: onRoomTypeChange,
        value: roomType
      }), /*#__PURE__*/_jsx(LayoutsCards, {
        layouts: layouts,
        isLoading: isLoading,
        isError: isError,
        onLayoutCardClick: onLayoutCardClick,
        onReset: onLayoutsReset,
        trackLayoutModalOpen: trackLayoutModalOpen,
        trackListingLinkClick: trackListingLinkClick,
        isLayoutModalDisabled: isLayoutModalDisabled
      }), /*#__PURE__*/_jsxs(Controls, {
        children: [!isError && /*#__PURE__*/_jsx(Pagination, {
          page: pagination.page,
          onChange: pagination.onPageChange,
          lastPage: pagination.lastPage
        }), !isLoading && /*#__PURE__*/_jsx(OffersLinks, {
          linksInfo: offersLinks,
          houseId: houseId,
          roomType: roomType,
          trackClick: trackListingLinkClick
        })]
      })]
    }), /*#__PURE__*/_jsx(LayoutModal, {
      onClose: onClose,
      onReset: onReset,
      open: isOpened,
      isLoading: isLayoutLoading,
      layoutImageUrl: layoutImageUrl,
      callButton: callButton,
      layoutOffers: layoutOffers,
      trackTourClick: trackTourClick,
      trackHeaderLinkClick: trackHeaderLinkClick,
      trackFlatCardClick: trackFlatCardClick,
      favoriteButton: favoriteButton
    })]
  });
};